import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-building-08",
  "use": "icon-building-08-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-building-08\">\r\n<path d=\"M3 21H21M6 18V10M10 18V10M14 18V10M18 18V10M20 7.00001L12.424 2.26501C12.2702 2.16887 12.1933 2.1208 12.1108 2.10206C12.0379 2.08549 11.9621 2.08549 11.8892 2.10206C11.8067 2.1208 11.7298 2.16887 11.576 2.26501L4 7.00001H20Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/building-08.svg
// module id = C16L
// module chunks = 80